// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'
import { formattedDate } from 'church-theme-library/utilities/date'

class BulletinDetails extends React.Component {
	render() {
		const { translate, page } = this.props

		if ( ! page || ! page.is_bulletin ) {
			return null
		}

		// Date:
		let bulletinDate = formattedDate( page )

		return (
			<div className="section-bulletin-details">
				<div className="-inner">
					{ page.file &&
						<section className="bulletin-file">
							<Editable
								id="set_bulletin_file"
								element="div"
							>
								<p>
									<a href={ page.file } className="button" target="_blank" rel="noopener">
										{ translate( 'Download' ) }
									</a>
								</p>
							</Editable>
						</section>
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

export default localize(
	connect( mapStateToProps )( BulletinDetails )
)
